import { render, staticRenderFns } from "./newFlagIcon.vue?vue&type=template&id=46fb7a93&scoped=true"
import script from "./newFlagIcon.vue?vue&type=script&lang=js"
export * from "./newFlagIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fb7a93",
  null
  
)

export default component.exports